/** Shared Target-role UI helpers (inherited marks on dockings only). */
const TARGET_SVG = `
  <svg class="role-dot-icon" viewBox="0 0 16 16" width="18" height="18" aria-hidden="true">
    <circle cx="8" cy="8" r="7.2" fill="currentColor"/>
    <circle cx="8" cy="8" r="4.6" fill="#fff"/>
    <circle cx="8" cy="8" r="2" fill="currentColor"/>
  </svg>
`.trim();
/** Current session Target receptorID from the receptor list DOM, or null. */
export function getMainTargetReceptorId() {
    const el = document.querySelector('.receptor-item[data-target-role="target"]');
    if (!el)
        return null;
    const id = parseInt(el.getAttribute('data-receptor-id') || '0', 10);
    return id > 0 ? id : null;
}
/** Non-clickable Target logo for jobs linked to the session MAIN. */
export function inheritedTargetMarkHtml(tooltip = 'Linked to session Target') {
    return (`<span class="role-dot role-dot-target role-dot-inherited" aria-label="${tooltip}" tabindex="0">` +
        TARGET_SVG +
        `<span class="mexa-tooltip role-dot-tooltip">${tooltip}</span>` +
        `</span>`);
}
export function upsertInheritedTargetMark(host, show, tooltip = 'Linked to session Target') {
    const existing = host.querySelector('.role-dot-inherited');
    if (!show) {
        existing === null || existing === void 0 ? void 0 : existing.remove();
        host.removeAttribute('data-linked-main-target');
        return;
    }
    host.setAttribute('data-linked-main-target', 'true');
    if (existing)
        return;
    host.insertAdjacentHTML('afterbegin', inheritedTargetMarkHtml(tooltip));
}
/** Refresh inherited Target marks on docking cards only (not peptides). */
export function refreshInheritedTargetMarks() {
    const mainRid = getMainTargetReceptorId();
    document.querySelectorAll('.docking-item').forEach((node) => {
        const el = node;
        const rid = parseInt(el.getAttribute('data-receptor-id') || '0', 10);
        upsertInheritedTargetMark(el, mainRid != null && rid === mainRid, 'Docking on session Target');
    });
    // Peptides are not Target-scoped — strip any leftover inherited marks.
    document.querySelectorAll('.peptide-item').forEach((node) => {
        upsertInheritedTargetMark(node, false);
    });
}
let inheritedMarksHooked = false;
/** Listen once for Target promo / list reloads. */
export function ensureInheritedTargetMarksHook() {
    if (inheritedMarksHooked)
        return;
    inheritedMarksHooked = true;
    window.addEventListener('mexa:main-target-changed', () => {
        refreshInheritedTargetMarks();
    });
    window.addEventListener('dockings-updated', () => {
        refreshInheritedTargetMarks();
    });
}
